<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="warning">
        <v-toolbar-title>
          {{ $t('Подача оферты') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-2">
        <v-alert
            class="text-center ma-1"
            outlined
            :value="true"
            type="error">
          {{ warningMessage1 }}
        </v-alert>
        <v-row class="py-2">
          <text-view
              v-if="!!dialogProp.stepValue"
              md="6"
              :display="dialogProp.stepValue"
              :label="premiumStepLabel" />
          <text-view
              v-if="!!dialogProp.deliveryBasisName"
              md="6"
              :display="dialogProp.deliveryBasisName"
              :label="$t('Порт/место назначения')" />
        </v-row>
        <v-data-table
            :headers="headers"
            :items="dialogProp.premiums || []"
            :items-per-page="-1"
            item-key="positionId"
            disable-sort-by
            :locale="systemLocale"
            hide-default-footer
            dense>
          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
          <template v-slot:item.positionDescription="{ item }">
            {{ item.positionDescription }}
          </template>
          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
          <template v-slot:item.premiumWithDelivery="{ item }">
            {{ item.premiumWithDelivery }}
          </template>
        </v-data-table>
        <v-divider />
        <v-row class="py-2">
          <v-col class="textcolor--text v-label">
            {{ warningMessage2 }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            color="primary"
            @click="cancel">
          {{ $t('Закрыть') }}
        </v-btn>
        <v-btn
            id="continueOperationBtn"
            color="warning"
            @click.stop="continueOperation">
          {{ $t('Подать') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'

  export default {
    components: {
      TextView
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            stepCount: null,
            organizationName: null,
            stepValue: null,
            deliveryBasisName: null,
            isFixPremium: null,
            premiums: [],
            callback: null
          }
        }
      }
    },
    data () {
      return { }
    },
    computed: {
      warningMessage1 () {
        return this.$t('Уведомляем, что отзыв оферты после её отправки в систему ЗАПРЕЩЕН.')
      },
      warningMessage2 () {
        return this.$t('В случае отказа от заключения Контракта по предложенной цене {0} будет отказано в участии в следующих процедурах реализации.',
                       [this.dialogProp.organizationName])
      },
      premiumStepLabel () {
        return this.$t(this.dialogProp.isFixPremium
          ? 'Шаг цены (без учета НДС, в валюте Контракта)'
          : 'Шаг дифференциала')
      },
      headers () {
        return [
          { text: this.$t('Наименование позиции'), align: 'start', sortable: false, value: 'positionDescription' },
          { text: this.premiumHeader, align: 'start', sortable: false, value: 'premiumWithDelivery' }
        ]
      },
      premiumHeader () {
        const premiumLabel = this.dialogProp.isFixPremium
          ? 'Значение цены в базисе поставки'
          : 'Значение дифференциала в базисе поставки'

        return this.$t(premiumLabel)
      }
    },
    methods: {
      continueOperation: function () {
        if (this.dialogProp.callback) {
          this.dialogProp.callback()
        }
        this.cancel()
      },
      cancel: function () {
        this.$emit('close')
        this.$emit('cancel')
      }
    }
  }
</script>
